
import React from "react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { AvatarUpload } from "./AvatarUpload";

interface ProfileFormData {
  displayName: string;
  disciplines: string;
  organisatie: string;
  yearsExperience: string;
  bio: string;
}

interface EditProfileDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  initialData: ProfileFormData;
  onSubmit: (data: ProfileFormData) => void;
  userId: string;
  avatarUrl: string | null;
  onAvatarUpload: (url: string) => void;
}

export function EditProfileDialog({
  open,
  onOpenChange,
  initialData,
  onSubmit,
  userId,
  avatarUrl,
  onAvatarUpload,
}: EditProfileDialogProps) {
  const [formData, setFormData] = React.useState<ProfileFormData>(initialData);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Bewerk profiel</DialogTitle>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4">
          <AvatarUpload
            uid={userId}
            url={avatarUrl}
            onUpload={onAvatarUpload}
          />
          <div className="space-y-2">
            <Label htmlFor="displayName">Weergavenaam</Label>
            <Input
              id="displayName"
              value={formData.displayName}
              onChange={(e) =>
                setFormData({ ...formData, displayName: e.target.value })
              }
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="disciplines">Disciplines</Label>
            <Input
              id="disciplines"
              value={formData.disciplines}
              onChange={(e) =>
                setFormData({ ...formData, disciplines: e.target.value })
              }
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="organisatie">Organisatie</Label>
            <Input
              id="organisatie"
              value={formData.organisatie}
              onChange={(e) =>
                setFormData({ ...formData, organisatie: e.target.value })
              }
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="yearsExperience">Jaren ervaring</Label>
            <Input
              id="yearsExperience"
              type="number"
              value={formData.yearsExperience}
              onChange={(e) =>
                setFormData({ ...formData, yearsExperience: e.target.value })
              }
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="bio">Bio</Label>
            <Textarea
              id="bio"
              value={formData.bio}
              onChange={(e) =>
                setFormData({ ...formData, bio: e.target.value })
              }
              rows={4}
            />
          </div>
          <DialogFooter>
            <Button type="submit">Opslaan</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
